const subscribeInput = document.querySelector(".recharge-subscription input");
const oneTimeInput = document.querySelector(".recharge-one__time input");
const rechargeSubscriptionFieldset = document.querySelector(".recharge-subscription");
const rechargeOneTimeFieldset = document.querySelector(".recharge-one__time");
const rechargeContainer = document.querySelector(".dn-selling-plan-container");
let priceWrapper = document.querySelector(".product-price");


subscribeInput.parentNode.addEventListener("click", function (e) {
  if (e.target !== subscribeInput) {
    if (!subscribeInput.checked) {
      subscribeInput.checked = true;
      oneTimeInput.checked = false;
    }
  }
  handleSubscribeInputChange();
});

oneTimeInput.parentNode.addEventListener("click", function (e) {
  if (e.target !== oneTimeInput) {
    if (!oneTimeInput.checked) {
      oneTimeInput.checked = true;
      subscribeInput.checked = false;
    }
  }
  handleOneTimeInputChange();
});

subscribeInput.addEventListener("change", function () {
  if (subscribeInput.checked) {
    oneTimeInput.checked = false;
    handleSubscribeInputChange();
  }
});

oneTimeInput.addEventListener("change", function () {
  if (oneTimeInput.checked) {
    subscribeInput.checked = false;
    handleOneTimeInputChange();
  }
});

function updatePriceElements(priceHtml) {
  // Update all price elements
  document.querySelectorAll('.product-price, .product-price-custom').forEach(function(el) {
    el.innerHTML = priceHtml;
  });
} 

function handleSubscribeInputChange() {
  if (subscribeInput.checked) {
    rechargeSubscriptionFieldset.style.borderColor = "#00C7B4";
    rechargeOneTimeFieldset.style.borderColor = "#c0c0c0";
    updatePriceElements(rechargeContainer.getAttribute("data-price-discount"));
  }
}

function handleOneTimeInputChange() {
  if (oneTimeInput.checked) {
    rechargeOneTimeFieldset.style.borderColor = "#00C7B4";
    rechargeSubscriptionFieldset.style.borderColor = "#c0c0c0";
    updatePriceElements(rechargeContainer.getAttribute("data-price-product"));
  }
}

// Initial handling of input state: only call the handler for the checked input
if (subscribeInput.checked) {
  handleSubscribeInputChange();
} else if (oneTimeInput.checked) {
  handleOneTimeInputChange();
}